<template>
  <div class="tab-pane fade active show">
    <div class="card" v-if="customer">
      <div class="card-body">
        <h4 class="mb-2">{{ "payments" | t }}</h4>
        <br />
        <table class="table mt-2 w-100">
          <thead>
            <tr>
              <th></th>
              <th>{{ "Id" }}</th>
              <th>{{ "Date" }}</th>
              <th>{{ "P-GW" }}</th>
              <th>{{ "Acc" }}</th>
              <th>{{ "Source" }}</th>
              <th>{{ "Status" }}</th>
              <th>{{ "Reference" }}</th>
              <th>{{ "Invoice" }}</th>
              <th>{{ "Completed" }}</th>
              <th class="text-right">{{ "Amount" }}</th>
              <th></th>
            </tr>
          </thead>
          <tr v-for="payment in payments" :key="payment.id">
            <td>
              <span
                class="badge badge-primary"
                v-if="payment.doc_type == 'payment'"
                >{{ "P" }}</span
              ><span
                class="badge badge-warning"
                v-if="payment.doc_type == 'refund'"
                >{{ "R" }}</span
              >
            </td>
            <td>{{ payment.id }}</td>
            <td>{{ payment.payment_date | datetime }}</td>
            <td>
              <i class="fa fa-check" v-if="payment.payment_reference"></i>
            </td>
            <td><i class="fa fa-check" v-if="payment.ext_ref"></i></td>
            <td>
              <i
                class="fa fa-building-o"
                v-if="payment.payment_source == 'bank'"
              ></i
              ><i
                class="fa fa-credit-card"
                v-if="payment.payment_source == 'credit_card'"
              ></i
              ><i
                class="fa fa-balance-scale"
                v-if="payment.payment_source == 'balance'"
              ></i>
            </td>
            <td>{{ payment.status | t }}</td>
            <td>
              <input
                class="form-control-plaintext"
                readonly="readonly"
                width="10"
                :value="payment.payment_reference"
              />
            </td>
            <td>{{ payment.invoice_id }}</td>
            <td>
              <i class="fa fa-check" v-if="payment.status == 'completed'"></i>
              <div v-else>
                <div class="text-danger" v-if="payment.error_message">
                  {{ payment.error_message }}
                </div>
              </div>
            </td>
            <td class="text-right">
              {{ payment.amount | currency }} {{ payment.currency }}
            </td>
            <td>
              <div
                class="btn btn-sm btn-outline-danger"
                v-if="
                  (payment.status != 'completed' && !payment.ext_ref) ||
                  payment.is_sepa
                "
                @click="deletePayment(payment)"
              >
                {{ "delete_payment" | t }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: Object,
    payments: Array,
  },
  methods: {
    deletePayment(payment) {
      this.$emit("deletePayment", payment);
    },
  },
};
</script>